export default __webpack_public_path__ + "static/bwtransport-3-d473f7753b173f0338af45bf7b8e157a.png";